const state = {
    requestPayload: {
        page: 1,
        perpage: 10,
        totemails: '',
        totspaceyemails: '',
        current_page_email_from_date: '',
        current_page_email_from_muid: '',
        panelist: 'home',
        sorting_field: 'email_date',
        sorting_direction: 'desc'
    },
    lastpage: 0,
    hasnext: false,
    responsePayload: [],
    start_time: 0,
    end_time: 0,
    isfromsearch: false,
    isloading: false,
    paging: '',
    ids_to_update: [],
    update_all: false,
    update_objects: [],
    competi_id: '',
    product_id: ''
}

export default state
